import { FC, useEffect, useState } from "react";
import { RouteProps, useLocation, useNavigate } from "react-router-dom";
import routes from "routes/routes";

import useAuth from "hooks/useAuth";

import { FullScreenLoader } from "uikit";

const UnauthorizedRoute: FC<RouteProps> = ({ children }) => {
  const navigate = useNavigate();
  const [userLoaded, setUserLoaded] = useState<boolean>(false);
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  useEffect(() => {
    async function checkUser() {
      if (isAuthenticated()) {
        navigate(routes.ROOT);
        return;
      }
      setUserLoaded(true);
    }

    checkUser();
  }, [location]);

  return <>{!userLoaded ? <FullScreenLoader /> : <>{children}</>}</>;
};

export default UnauthorizedRoute;
